module.exports = __webpack_public_path__ + "static/media/t2-img1.e0dfa009.png";